<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { GDialog } from 'gitart-vue-dialog';
import DisplayFailedList from "@/components/DailyReportParts/DisplayFailedList.vue";
import CopyButton from "@/components/Common/CopyButton.vue"
import i18n from '@/lang/i18n';

const emits = defineEmits(['closeModal'])
const props = defineProps<{
  state: boolean
  modalDisplayData: [string][]
  message: string
  operationOfficeName: string
}>()

const modalTitle = i18n.global.t('pages.dailyReports.failedTripIdsModal.tripIdList') as string
const localState = ref(false as boolean)
const closeBtnName = i18n.global.t('pages.common.button.close') as string
const isCopied = ref(true as boolean)
const operationOfficeNameLabel = i18n.global.t('pages.dailyReports.failedTripIdsModal.operationOfficeName') as string

const copyedValue = computed(() => {
  let copyedValue = ""
  copyedValue = `${operationOfficeNameLabel}${props.operationOfficeName}\n`
  props.modalDisplayData.forEach((tripId) => {
    copyedValue += `${tripId}\n`
  })
  return copyedValue
})

function close() {
  emits("closeModal", false)
}

watch(() => props.state, (bool) => {
  localState.value = bool
})
</script>
<template>
  <GDialog
    v-model="localState"
    max-width="45%"
    :height="props.modalDisplayData.length < 10 ? 'auto' : '65%'"
    transition="custom-from-bottom-transition"
    :persistent='true'
  >
    <div class="modal-header justify-content-center mt-4">
      <div style="border-bottom: 2px solid rgb(21, 130, 156); width: 98%">
        <h5
          class="d-flex fw-bold mb-2 justify-content-center"
        >
          {{ modalTitle }}
        </h5>
      </div>
    </div>
    <div class="modal-body mx-4 mt-4">
      <div class="w-100 d-flex justify-space-between mt-4 mb-6">
        <div>
          {{ operationOfficeName }} {{ props.operationOfficeName }}
        </div>
        <CopyButton
          :copyText="copyedValue"
          v-model="isCopied"
        />
      </div>
      <DisplayFailedList
        :tripIdList="props.modalDisplayData"
      />
    </div>
    <div class="modal-footer m-3 mt-2">
      <v-btn class="d-flex justify-content-end close-btn" @click="close">
        {{ closeBtnName }}
      </v-btn>
    </div>
  </GDialog>
</template>